<template>
  <div class="scrollable">
  	<v-header></v-header>
    <div class="content">
    	<div class="breadNav">
        <P>{{$t('m.suggestions.brankNav')}}</P>
      </div>
      <div class="divMsg">
        <div class="divLeft" @click="myd">
          <img v-if="qhText=='en'" src="../../../assets/满意度调查-EN.jpg">
          <img v-else  src="../../../assets/满意度调查.jpg">
          <p>{{$t('m.phyOrderList.orderItem.degree')}}</p>
        </div>
        <div class="divRight" @click="tu">
          <img v-if="qhText=='en'" src="../../../assets/投诉建议-EN.jpg">
          <img v-else  src="../../../assets/投诉建议.jpg">
          <p>{{$t('m.phyIndex.suggestionModel')}}</p>
        </div>
      </div>
    </div>
  	<v-footer></v-footer>
  </div>
</template>

<script>
    import axios from 'axios';
    import {
        mapActions,
        mapGetters
    } from 'vuex';
    import header from '../../common/header.vue'
    import footer from '../../common/footer.vue'
    export default {
        name: 'Suggestions',
        data() {
            return {
                radio: '',
                fullscreenLoading: false
            }
        },
        components: {
            "v-header": header,
            "v-footer": footer
        },
        created() {

        },
        methods: {
            ...mapActions( // 语法糖
                ['message'] // 相当于this.$store.dispatch('modifyName'),提交这个方法
            ),

            myd() {
                let url;
                if (this.qhText == 'en') {
                    url = 'https://wj.bytedance.com/q/14709/ztx9z771/dc18/'
                } else {
                    url = 'https://wj.bytedance.com/q/14709/ztx9z771/dc18/'
                }
                window.open(url);
            },
            tu() {
                window.open('https://applink.feishu.cn/client/helpdesk/open?id=6512629154104492302');
            },

            submit() {
                let _this = this;
                console.log(_this.radio)
                if (_this.radio === '') {
                    console.log('33')
                    let data = {
                        message: _this.$t('m.suggestions.suType'),
                        type: 'error',
                        center: true
                    }
                    _this.message(data);
                } else if (_this.$refs.msg.value == '') {
                    let data = {
                        message: _this.$t('m.suggestions.suMsg'),
                        type: 'error',
                        center: true
                    }
                    _this.message(data);
                } else {
                    let params = {
                        type: _this.radio,
                        content: _this.$refs.msg.value,
                    };
                    if (_this.$refs.phone.value != '') {
                        params.contact = _this.$refs.phone.value
                    }
                    _this.fullscreenLoading = true;
                    axios.post(BASE_URL + '/exam/feedback/', params).then((res) => {
                        // console.log(res);
                        _this.fullscreenLoading = false;
                        let data = {
                            message: _this.$t('m.suggestions.success'),
                            type: 'success',
                            center: true
                        }
                        _this.message(data);
                        _this.$router.go(-1);
                    }).catch((err) => {
                        console.log(err)
                        _this.fullscreenLoading = false;
                    })
                }
            }
        },
        computed: {
            ...mapGetters(['qhText'])
        }
    }
</script>

<style scoped>
    .divMsg {
        width: 1180px;
        margin: 0 auto;
        padding: 80px 0 120px 0;
        display: flex;
        justify-content: space-between;
    }
    
    .divLeft,
    .divRight {
        width: 560px;
        height: 400px;
        background: #fff;
        box-shadow: 0px 0px 30px 0px rgba(197, 197, 197, 0.35);
        border-radius: 10px;
        cursor: pointer;
    }
    
    .divLeft img,
    .divRight img {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        width: 100%;
    }
    
    .divLeft p,
    .divRight p {
        font-size: 30px;
        font-weight: 600;
        color: #333;
        line-height: 30px;
        margin-top: 53px;
        text-align: center;
    }
    
    .submit {
        width: 1180px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        padding: 30px 0 58px 0;
    }
    
    .submit p {
        width: 180px;
        height: 46px;
        background: #E51E26;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    
    .phone {
        width: 1180px;
        margin: 0 auto;
    }
    
    .phone input {
        width: 1180px;
        height: 76px;
        border: 1px solid #ccc;
        padding-left: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
    }
    
    .suMsg {
        width: 1180px;
        margin: 0 auto;
    }
    
    .suMsg textarea {
        width: 1180px;
        height: 250px;
        border: 1px solid #ccc;
        padding: 30px;
        font-size: 16px;
        font-weight: 400;
        color: #333;
        line-height: 16px;
    }
    
    .sutype {
        width: 1180px;
        height: 78px;
        border: 1px solid #ccc;
        margin: 0 auto;
        display: flex;
        align-items: center;
        padding-left: 30px;
    }
    
    .tit {
        width: 1180px;
        height: 78px;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
    
    .tit i {
        width: 4px;
        height: 18px;
        background: #e94709;
    }
    
    .tit p {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .bottom {
        margin: 30px 0 50px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .bottom p:nth-child(1) {
        width: 180px;
        height: 46px;
        background: #E51E26;
        font-size: 16px;
        font-weight: 600;
        color: #fff;
        line-height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    
    .bottom p:nth-child(2) {
        font-size: 18px;
        font-weight: 400;
        color: #333;
        line-height: 18px;
        margin-left: 30px;
    }
    
    .bottom p:nth-child(3) {
        font-size: 18px;
        font-weight: 600;
        color: #E51E26;
        line-height: 18px;
        margin-left: 30px;
    }
    
    .item .msg {
        margin-top: 23px;
    }
    
    .item .msg p {
        font-size: 18px;
        font-weight: 400;
        color: #333;
        line-height: 30px;
    }
    
    .item .tit p:nth-child(1) {
        width: 4px;
        height: 18px;
        background: #e94709;
    }
    
    .item .tit p:nth-child(2) {
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 18px;
        margin-left: 7px;
    }
    
    .item .tit {
        display: flex;
        align-items: center;
    }
    
    .item {
        width: 1180px;
        margin: 0 auto;
        padding: 30px;
        border: 1px solid #ccc;
        margin-top: 30px;
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #EAEAEA;
        display: flex;
        align-items: center;
    }
    
    .breadNav p {
        width: 1180px;
        margin: 0 auto;
        font-size: 18px;
        font-weight: 600;
        color: #333;
        line-height: 20px;
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/suggestions/index.vue